import AbstractEntity, {AbstractEntityFields} from "~/ts/library/AbstractEntity";
import {FiltersCollection} from "~/cabinet/vue/interface/filter/Interfaces";
import {ContentVariableInterface} from "~/cabinet/vue/interface/ContentVariableInterface";
import EventPlatform from "~/cabinet/ts/data/events/EventPlatform";
import AbstractActionDescription from "~/cabinet/ts/data/events/AbstractActionDescription";
import {VirtualOperatorConfigInterface} from "~/cabinet/vue/client/online/config/operators/virtual/Interface";
import {ref, Ref} from "vue";

let onlineChatMessageToClientWeakMap = new WeakMap();

export class EventParamsByAuth extends AbstractEntity {
    eventId: string;
    authId: string;
    isHidden: boolean;
    authPrimaryId: string;
    actions: AbstractActionDescription<any>[];
    filtersCollection: FiltersCollection;
    descr: string;
    contentVariables: ContentVariableInterface[];
    platform: EventPlatform;
    eventParams: EventParamsInterface;
    webhookData?: any;
    globalVarsPrefixKey: string;
    eventDescriptionsForTarget: EventDescriptionForTargetInterface[];
    maxActionsCount?: number;
    isActionBlockCanBeDisabledInEventRegister: boolean;
    isEventRegisterDescriptionRequired: boolean;
    isManualExportToDataProvider: boolean;
    virtualOperators: VirtualOperatorConfigInterface[];

    protected getFields(): AbstractEntityFields {
        return {
            platform: EventPlatform,
            actions: AbstractActionDescription<any>
        }
    }

    protected isFreezeObject(): boolean {
        return true;
    }

    getVirtualOperators(): VirtualOperatorConfigInterface[] {
        let result: Ref<VirtualOperatorConfigInterface[]> = onlineChatMessageToClientWeakMap.get(this);
        if (!result) {
            result = ref([...this.virtualOperators]);
            onlineChatMessageToClientWeakMap.set(this, result);
        }
        return result.value;
    }
}

export interface EventParamsInterface {
    isRunOnlyFirstMatchedRegister: boolean
}

export interface IdentifiersInEventDescriptionForTargetInterface {
    id: string;
    descr: string;
    isEnabledByDefault: boolean;
}

export interface EventDescriptionForTargetInterface {
    id: string;
    descr: string;
    identifiersList: IdentifiersInEventDescriptionForTargetInterface[];
    typeDescr: string;
}